export const arcadesSelector = (state: any) => state.arcades;
